import React, { useEffect } from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel, getAccessColor } from '../access-control/utils';

export default function CameraAccessTable({ 
  caps, 
  userCaps, 
  user, 
  handleAccessChange,
  handleNotificationChange,
  renderLastAccess, 
  isMobile, 
  history 
}) {

  return (
    <Table bordered condensed striped hover className="cap-access-table">
      <thead>
        {isMobile && (
            <tr>
                <th></th>
                <th colSpan="2" style={{ textAlign: 'center' }}>Access</th>
                <th colSpan="2" style={{ textAlign: 'center' }}>Power Notifications</th>
            </tr>
        )}
          <tr>
            <th style={{ width: '200px', fontSize: isMobile ? '0.9em' : 'inherit' }}>Camera</th>
            <th style={{ width: '200px', fontSize: isMobile ? '0.9em' : 'inherit' }}>{isMobile ? 'Tier' : 'Access Tier'}</th>
          <th style={{ width: '200px', fontSize: isMobile ? '0.9em' : 'inherit' }}>{isMobile ? 'Login' : 'Last Accessed'}</th>
          <th style={{ width: '100px', fontSize: isMobile ? '0.9em' : 'inherit', whiteSpace: 'normal', textAlign: 'center'}}>{isMobile ? 'Email' : 'Power Emails'}</th>
          <th style={{ width: '100px', fontSize: isMobile ? '0.9em' : 'inherit', whiteSpace: 'normal', textAlign: 'center'}}>{isMobile ? 'App' : 'Power App Notifications'}</th>
        </tr>
      </thead>
      <tbody>
        {caps.map(cap => {
          const userCap = userCaps.find(
            uc => uc.userId === user.userId && uc.capId === cap.capId
          );
          const accessLevel = userCap ? userCap.accessType : 'No Access';
          const backgroundColor = getAccessColor(accessLevel);
          
          return (
            <tr key={cap.capId}>
              <td className="cap-name-cell">
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/caps/${cap.capId}`)}
                  className="cap-name-button"
                  disabled={cap.status !== 'ACTIVE'}
                  bsSize={isMobile ? "xs" : null}
                  style={{whiteSpace: 'normal', textAlign: 'left', fontSize: isMobile ? '0.8em' : 'inherit'}}
                >
                  {cap.name}
                </Button>
              </td>
              <td>
                <DropdownButton
                  title={getReadableAccessLevel(accessLevel, null, isMobile)}
                  id={`dropdown-${user.userId}-${cap.capId}`}
                  onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                  style={{backgroundColor}}
                  disabled={user.builderStatus === 'ADMIN' || cap.status !== 'ACTIVE'}
                  bsSize={isMobile ? "xs" : null}
                >
                  <MenuItem eventKey="No Access" style={{ backgroundColor: getAccessColor('No Access')}}>{getReadableAccessLevel('No Access', null, isMobile)}</MenuItem>
                  <MenuItem eventKey="DEMO" style={{ backgroundColor: getAccessColor('DEMO')}}>{getReadableAccessLevel('DEMO', null, isMobile)}</MenuItem>
                  <MenuItem eventKey="VIEWER" style={{ backgroundColor: getAccessColor('VIEWER')}}>{getReadableAccessLevel('VIEWER', null, isMobile)}</MenuItem>
                  <MenuItem eventKey="OWNER" style={{ backgroundColor: getAccessColor('OWNER')}}>{getReadableAccessLevel('OWNER', null, isMobile)}</MenuItem>
                  {getUser().role==='ADMIN' && (<MenuItem eventKey="SALES_DEMO" style={{ backgroundColor: getAccessColor('SALES_DEMO')}}>{getReadableAccessLevel('SALES_DEMO', null, isMobile)}</MenuItem>)}
                </DropdownButton>
              </td>
              <td>{renderLastAccess(cap.capId)}</td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={userCap?.powerNotifications ?? false}
                      onChange={(e) => handleNotificationChange(user.userId, cap.capId, 'powerNotifications', e.target.checked)}
                      disabled={!userCap || userCap.accessType === 'No Access'}
                    />
                    <span className="elegant-checkbox-slider"></span>
                  </label>
                </div>
              </td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={userCap?.appNotifications ?? false}
                      onChange={(e) => handleNotificationChange(user.userId, cap.capId, 'appNotifications', e.target.checked)}
                      disabled={!userCap || userCap.accessType === 'No Access'}
                    />
                    <span className="elegant-checkbox-slider"></span>
                  </label>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
} 